import { StyledEngineProvider, ThemeProvider } from '@mui/material';
import React, { ReactNode, useEffect } from 'react';
import { useThemeStore } from '../../../store/theme/themeStore';
import { themeCreator } from '../base';

export const ThemeContext = React.createContext((themeName: string): void => {
  themeCreator(themeName);
});

interface IThemeProviderWrapper {
  children: ReactNode;
}

const ThemeProviderWrapper: React.FC<IThemeProviderWrapper> = (props) => {
  const theme = useThemeStore((state) => state.theme);
  const setTheme = useThemeStore((state) => state.setTheme);

  const setThemeName = (themeName: string): void => {
    setTheme(themeName);
  };

  useEffect(() => {
    setThemeName(theme);
  }, [theme, setThemeName]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeContext.Provider value={setThemeName}>
        <ThemeProvider theme={themeCreator(theme)}>
          {props.children}
        </ThemeProvider>
      </ThemeContext.Provider>
    </StyledEngineProvider>
  );
};

export default ThemeProviderWrapper;
